import { render, staticRenderFns } from "./BidsModal.vue?vue&type=template&id=490a912a&scoped=true"
import script from "./BidsModal.vue?vue&type=script&lang=js"
export * from "./BidsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490a912a",
  null
  
)

export default component.exports